// @flow

import * as React from 'react';
import Box from 'sail/Box';

type CodeTabProps = {
  title: string,
  id: string,
  children: React.Node,
};

export const CodeTab = ({children}: CodeTabProps) => <Box>{children}</Box>;
